import Swiper from 'swiper';

/*/
 * Home
/*/
	const swiperHomeOptions = {
		// modules: [Autoplay],
		loopAdditionalSlides: 6,
		loop: true,
		slidesPerView: 'auto',
		// speed: 30000,
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		on: {
			// touchStart: function (el) {
			// 	el.params.speed = 500
			// 	el.$wrapperEl[0].style.setProperty('transition-timing-function', 'ease')
			// }
		}
	}

	const siteSwiperHome1 = document.querySelectorAll('[site-swiper-home]')[0]
	const siteSwiperHome2 = document.querySelectorAll('[site-swiper-home]')[1]
	const siteSwiperHome3 = document.querySelectorAll('[site-swiper-home]')[2]

	const swiperHome1 = new Swiper(siteSwiperHome1, { ...swiperHomeOptions })
	const swiperHome2 = new Swiper(siteSwiperHome2, { ...swiperHomeOptions })
	const swiperHome3 = new Swiper(siteSwiperHome3, { ...swiperHomeOptions })

	// window.addEventListener('load', _ => {
	// 	swiperHome1.params.autoplay.delay = 1
	// 	swiperHome1.params.autoplay.disableOnInteraction = true
	// 	swiperHome1.params.autoplay.pauseOnMouseEnter = false
	// 	swiperHome1.params.autoplay.reverseDirection = false
	// 	swiperHome1.autoplay.start()

	// 	swiperHome2.params.autoplay.delay = 1
	// 	swiperHome2.params.autoplay.disableOnInteraction = true
	// 	swiperHome2.params.autoplay.pauseOnMouseEnter = false
	// 	swiperHome2.params.autoplay.reverseDirection = true
	// 	swiperHome2.autoplay.start()

	// 	swiperHome3.params.autoplay.delay = 1
	// 	swiperHome3.params.autoplay.disableOnInteraction = true
	// 	swiperHome3.params.autoplay.pauseOnMouseEnter = false
	// 	swiperHome3.params.autoplay.reverseDirection = false
	// 	swiperHome3.autoplay.start()
	// })

	// color mode bug fix
	const appColorTheme = document.querySelector('[app-color-theme]')

	if (appColorTheme) {
		appColorTheme.addEventListener('click', e => {
			e.preventDefault()

			setTimeout(() => {
				if (document.querySelector('#app').classList.contains('index')) {
					// swiperHome1.destroy()
					// swiperHome2.destroy()
					// swiperHome3.destroy()

					// const newHomeSwiper1 = new Swiper(siteSwiperHome1, { ...swiperHomeOptions })
					// const newHomeSwiper2 = new Swiper(siteSwiperHome2, { ...swiperHomeOptions })
					// const newHomeSwiper3 = new Swiper(siteSwiperHome3, { ...swiperHomeOptions })

					// setTimeout(() => {
					// 	newHomeSwiper1.params.autoplay.delay = 1
					// 	newHomeSwiper1.params.autoplay.disableOnInteraction = true
					// 	newHomeSwiper1.params.autoplay.pauseOnMouseEnter = false
					// 	newHomeSwiper1.params.autoplay.reverseDirection = false
					// 	newHomeSwiper1.autoplay.start()

					// 	newHomeSwiper2.params.autoplay.delay = 1
					// 	newHomeSwiper2.params.autoplay.disableOnInteraction = true
					// 	newHomeSwiper2.params.autoplay.pauseOnMouseEnter = false
					// 	newHomeSwiper2.params.autoplay.reverseDirection = true
					// 	newHomeSwiper2.autoplay.start()

					// 	newHomeSwiper3.params.autoplay.delay = 1
					// 	newHomeSwiper3.params.autoplay.disableOnInteraction = true
					// 	newHomeSwiper3.params.autoplay.pauseOnMouseEnter = false
					// 	newHomeSwiper3.params.autoplay.reverseDirection = false
					// 	newHomeSwiper3.autoplay.start()
					// }, 600)
				}
			}, 500)
		})
	}

	// inactive tab fix
	// document.addEventListener('visibilitychange', function () {
	// 	if (document.hidden) {
	// 		swiperHome1.autoplay.pause()
	// 		swiperHome2.autoplay.pause()
	// 		swiperHome3.autoplay.pause()
	// 	} else {
	// 		swiperHome1.autoplay.resume()
	// 		swiperHome2.autoplay.resume()
	// 		swiperHome3.autoplay.resume()
	// 	}
	// });


/*/
 * Team
/*/
	const swiper = new Swiper('[site-swiper-team]', {
		loop: true,
		slidesPerView: 'auto',
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		slideToClickedSlide: document.documentElement.offsetWidth < 992 ? true : false,
	})


/*/
 * Project
/*/
	const swiperProject = new Swiper('[site-swiper-project]', {
		loop: false,
		slidesPerView: 'auto',
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
	})

	window.addEventListener('load', _ => {
		setTimeout(() => {
			if (swiperProject.$el && swiperProject.virtualSize > swiperProject.width) {
				swiperProject.$wrapperEl[0].classList.remove('is--right')
			} else if (swiperProject.$el) {
				swiperProject.$wrapperEl[0].classList.add('is--right')
			}
		}, 200)
	})

	swiperProject.on('resize', _ => {
		setTimeout(() => {
			if (swiperProject.$el && swiperProject.virtualSize > swiperProject.width) {
				swiperProject.$wrapperEl[0].classList.remove('is--right')
			} else if (swiperProject.$el) {
				swiperProject.$wrapperEl[0].classList.add('is--right')
			}
		}, 100)
	})
